// Dependency-free, public-safe config. Do NOT import ../src/config.js or
// ../src/utils/getEnvironments.js from here - both are fine for the
// authenticated app, but this module backs the public, unauthenticated bundle
// and must never pull in anything that reads localStorage/auth tokens.
//
// Origins are explicit per environment below, with env var overrides for
// cases (a new staging host, a one-off local port) not worth a new branch.
// Restricting the API's CORS origin is not authorization - it stops a
// browser page on another origin from reading the response, nothing else.
// Anonymous layout and catalog requests are authorized by their dedicated
// backend contracts; the browser origin is not treated as authorization.

import { PORTAL_APP_URLS_BY_ENV } from '../src/utils/portalOrigins'

const ENV = import.meta.env.VITE_CHAINIO_ENV || 'test'

const ORIGINS_BY_ENV = {
  test: {
    publicAppUrl: 'http://localhost:5173',
    apiUrl: 'https://xrgkbnvu51.execute-api.us-east-1.amazonaws.com/red',
    portalAppUrl: PORTAL_APP_URLS_BY_ENV.test
  },
  red: {
    publicAppUrl: 'https://red-planner.chain.io',
    apiUrl: 'https://xrgkbnvu51.execute-api.us-east-1.amazonaws.com/red',
    portalAppUrl: PORTAL_APP_URLS_BY_ENV.red
  },
  production: {
    publicAppUrl: 'https://planner.chain.io',
    apiUrl: 'https://9u4fn4zkci.execute-api.us-east-1.amazonaws.com/production',
    portalAppUrl: PORTAL_APP_URLS_BY_ENV.production
  }
}

const origins = ORIGINS_BY_ENV[ENV] || ORIGINS_BY_ENV.test

export const publicAppUrl = import.meta.env.VITE_PUBLIC_APP_URL || origins.publicAppUrl
export const apiUrl = import.meta.env.VITE_PUBLIC_API_URL || origins.apiUrl
// The authenticated portal, linked to from the "moved into a workspace" notice once a
// layout has been claimed. A plain link only - the public bundle never talks to it.
export const portalAppUrl = import.meta.env.VITE_PUBLIC_PORTAL_URL || origins.portalAppUrl
// This is the established public policy location. Keep the public bundle
// independently configurable because its origin is separate from the portal.
export const publicPrivacyPolicyUrl = import.meta.env.VITE_PUBLIC_PRIVACY_POLICY_URL || 'https://chain.io/privacy-policy'
